import axios from './axios';
import { MediaListItem } from './users';

export interface GalleryResponse {
    media: MediaListItem[]
}
export const getGallery = (galleryId: string) => {
    return axios.get<GalleryResponse>(`/gallerys/${galleryId}`);
}